import { Item } from 'react-stately';
import { useUpdateDeliverySchedule } from '@hungryroot/app-mhr';
import { useIdentify } from '@hungryroot/customer';
import { Heading, Paragraph, Select } from '@hungryroot/ramen';

import { type Frequency } from '@hungryroot/rest';
import styles from './OrderFrequencySelector.module.css';

const frequencyOptions = [
  {
    label: 'Weekly',
    value: '7',
    subtext: "You'll get a delivery every week.",
  },
  {
    label: 'Biweekly',
    value: '14',
    subtext: "You'll get a delivery every other week.",
  },
];

export function OrderFrequencySelector() {
  const { customerData } = useIdentify();

  const updateDeliverySchedule = useUpdateDeliverySchedule();

  return (
    <div className={styles['order-frequency-selector-container']}>
      <Heading
        variant="H4"
        className={styles['order-frequency-selector-heading']}
      >
        Order frequency
      </Heading>
      <div>
        <Select
          buttonClassName={styles['order-frequency-selector-button']}
          containerClassName={styles['order-frequency-selector']}
          testid="frequency"
          aria-label="Frequency"
          items={frequencyOptions}
          selectedKey={customerData?.frequency?.toString()}
          onSelectionChange={(value) => {
            updateDeliverySchedule.mutate({
              frequency: value as Frequency,
            });
          }}
        >
          {(item) => (
            <Item key={item.value}>
              <span className={styles['frequency-item']}>
                <Paragraph
                  variant="body"
                  className={styles['frequency-item-label']}
                >
                  {item.label}
                </Paragraph>
                <Paragraph variant="caption">{item.subtext}</Paragraph>
              </span>
            </Item>
          )}
        </Select>
      </div>
    </div>
  );
}
